<template>
  <div class="radio_group">
    <slot></slot>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
.radio_group .b-radio.radio {
  display: flex;
  margin-bottom: 8px;
}

.radio_group .b-radio.radio + .radio {
  margin-left: 0;
}
</style>